var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpdate = function SvgUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    width: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 40.55q-5.85 0-9.925-4.075Q2 32.4 2 26.55q0-6.15 4.375-10.025T16.15 13l-4.3-4.3L14 6.55l8 8-8 8-2.15-2.15 4.45-4.45q-4.75-.1-8.025 2.9Q5 21.85 5 26.55q0 4.55 3.225 7.775Q11.45 37.55 16 37.55h6v3Zm10-18v-14h18v14Zm0 18v-14h18v14Zm3-3h12v-8H29Z",
    fill: "#8d8d8d"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/update.46d4d5e8.svg";
export { ForwardRef as ReactComponent };